const getModule = {
  state: {
    selected: false,
    url: '',
    type: '',
  },
  mutations: {
    setBuyukSehirNIP(state, data) {
      if (state.type == data.type) {
        state.selected = false
        state.url = ''
        state.type = ''
      } else {
        state.selected = true
        state.url = data.url
        state.type = data.type
      }
    },
  },
  actions: {
    setBuyukSehirNIP({ commit }, data) {
      commit('setBuyukSehirNIP', data)
    },
  },
  getters: {},
}

export default getModule
